export function initLightbox() {
  const galleryCards = document.querySelectorAll('.kg-image-card');
  galleryCards.forEach((galleryCard) => {
    galleryCard.setAttribute('data-te-lightbox-init', '');
  });
}
